import { z } from 'zod';
import { upsertLabTestSchema, upsertRadiologyStudyTypeSchema } from './dto/diagnostics';
export const ORDERABLE_TYPES = ['lab', 'radiology', 'procedure'];
export const ORDERABLES_PAGE_DEFAULT = 50;
export const ORDERABLES_PAGE_MAX = 100;
export const orderablesQuerySchema = z.object({
    type: z.enum(ORDERABLE_TYPES),
    q: z.string().trim().max(120).optional(),
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(ORDERABLES_PAGE_MAX).default(ORDERABLES_PAGE_DEFAULT),
});
function holds(modules, module) {
    return Array.isArray(modules) ? modules.includes(module) : modules.has(module);
}
export function orderableModule(type) {
    if (type === 'lab')
        return 'lab';
    if (type === 'radiology')
        return 'radiology';
    return null;
}
export function orderableInHouse(item, modules) {
    if (!item.priced)
        return false;
    if (item.type === 'lab')
        return holds(modules, 'lab') && Boolean(item.labTestId || item.labPanelId);
    if (item.type === 'radiology')
        return holds(modules, 'radiology') && Boolean(item.radiologyStudyTypeId);
    return true;
}
export function servicePriceRequired(category, modules) {
    if (category === 'procedure')
        return true;
    if (category === 'lab')
        return holds(modules, 'lab');
    if (category === 'radiology')
        return holds(modules, 'radiology');
    return false;
}
export function priceRequiredCategories(modules) {
    return ['lab', 'radiology', 'procedure'].filter((category) => servicePriceRequired(category, modules));
}
export function servicePriceProblem(category, basePriceMinor, modules) {
    if (basePriceMinor > 0 || !servicePriceRequired(category, modules))
        return null;
    if (category === 'procedure')
        return 'A procedure is performed here, so it needs a price';
    if (category === 'lab')
        return 'The laboratory is part of your plan, so a lab test needs a price before it can be done here';
    return 'Radiology is part of your plan, so an imaging study needs a price before it can be done here';
}
export function catalogueCodeForService(serviceCode, prefix) {
    const upper = serviceCode.trim().toUpperCase();
    const marker = `${prefix}-`;
    return upper.startsWith(marker) && upper.length > marker.length ? upper.slice(marker.length) : upper;
}
export const serviceLabDetailsSchema = upsertLabTestSchema
    .pick({ departmentGroup: true, specimenType: true, tatMinutes: true, resultType: true })
    .extend({
    containerType: z.string().trim().max(80).nullable().optional(),
    unit: z.string().trim().max(24).nullable().optional(),
});
export const serviceImagingDetailsSchema = upsertRadiologyStudyTypeSchema
    .pick({ modality: true, requiresContrast: true, requiresAppointment: true })
    .extend({
    bodyPart: z.string().trim().max(120).nullable().optional(),
});
//# sourceMappingURL=orderables.js.map